/* ═══════════════════════════════════════════
   BAU BUNDLE — State Manager v3.1
   Front D-Ring automatico
   ═══════════════════════════════════════════ */

(function () {
  'use strict';

  var SIZE_GROUPS = {
    SMALL: ['xs', 's', 'm', 'xxs'],
    LARGE: ['l', 'xl', 'xxl', 'xxxl']
  };

  function getSizeGroup(size) {
    if (!size) return null;
    var s = size.toLowerCase().trim();
    if (SIZE_GROUPS.SMALL.indexOf(s) !== -1) return 'small';
    if (SIZE_GROUPS.LARGE.indexOf(s) !== -1) return 'large';
    return null;
  }

  var LEASH_KEY_FOR_GROUP = {
    small: 'guinzaglio',
    large: 'guinzaglio_large'
  };

  var LEASH_SIZE_LABEL = {
    guinzaglio:       'Cani XS-M',
    guinzaglio_large: 'Cani L-XXL'
  };


  function normalize(value) {
    return (value || '').toLowerCase().trim();
  }

  function preferredLeashColor(pettorinaColor) {
    var c = normalize(pettorinaColor);
    if (c.indexOf('crimson') !== -1) return 'Crimson Edition';
    if (c.indexOf('lucky') !== -1) return 'Lucky Edition';
    if (c.indexOf('solar') !== -1) return 'Solar Edition';
    return 'Midnight Edition';
  }

  function preferredBagColor(pettorinaColor) {
    var c = normalize(pettorinaColor);
    if (c.indexOf('sakura') !== -1 || c.indexOf('rosa') !== -1 || c.indexOf('pink') !== -1) return 'Sakura Edition';
    return 'Midnight Edition';
  }

  function frontDTargetForHarness(size) {
    var s = normalize(size).replace(/\s+/g, '');
    if (s === 'xxs' || s === 'xs') return 'xxs-xs';
    if (s === 's') return 's';
    if (s === 'm') return 'm';
    if (s === 'l' || s === 'xl' || s === 'xxl' || s === 'xxxl') return 'l-xxl';
    return null;
  }

  function frontDVariantMatches(variant, target) {
    if (!variant || !target) return false;
    var values = [variant.title, variant.option1, variant.option2, variant.option3]
      .filter(Boolean)
      .map(function (v) { return normalize(v).replace(/\s+/g, '').replace(/[–—]/g, '-'); });

    if (target === 'xxs-xs') {
      return values.some(function (v) { return v === 'xxs-xs' || v === 'xxs/xs' || v === 'xxsxs'; });
    }
    if (target === 'l-xxl') {
      return values.some(function (v) { return v === 'l-xxl' || v === 'l/xxl' || v === 'lxxl'; });
    }
    return values.some(function (v) { return v === target; });
  }


  var BauBundleState = {

    selections: {
      pettorina:    { variantId: null, color: '', size: '', price: 0, compareAtPrice: 0, image: '' },
      guinzaglio:   { variantId: null, color: '', size: '', price: 0, compareAtPrice: 0, image: '' },
      portabustine: { variantId: null, color: '', size: '', price: 0, compareAtPrice: 0, image: '' }
    },

    freeProducts: {
      ebook:        { variantId: null, price: 0, compareAtPrice: 0, image: '', title: '' },
      front_d_ring: { variantId: null, price: 0, compareAtPrice: 9.99, image: '', title: '', sizeLabel: '' }
    },

    activeLeashKey: 'guinzaglio',
    openDropdown: null,
    subtotal: 0,
    fullPrice: 0,
    savings: 0,
    _initialized: false,

    init: function () {
      if (this._initialized) return;

      var products = window.BauBundleProducts;
      if (!products || !products.isReady()) {
        window.addEventListener('bau-bundle:products-ready', function () {
          BauBundleState.init();
        }, { once: true });
        return;
      }

      var self = this;

      /* ── Init pettorina ── */
      var petDv = products.getDefaultVariant('pettorina');
      if (petDv) {
        self.selections['pettorina'] = {
          variantId: petDv.id,
          color: petDv.option1 || '',
          size:  petDv.option2 || '',
          price: petDv.price,
          compareAtPrice: petDv.compareAtPrice || petDv.price,
          image: petDv.image || (products.getProduct('pettorina') || {}).featuredImage || ''
        };
      }

      /* ── Determine active leash from default pettorina size ── */
      var defaultSize  = petDv ? (petDv.option2 || '') : '';
      var defaultGroup = getSizeGroup(defaultSize);
      self.activeLeashKey = (defaultGroup && LEASH_KEY_FOR_GROUP[defaultGroup]) || 'guinzaglio';

      /* ── Init active leash ── */
      var leashProductInit = products.getProduct(self.activeLeashKey);
      var leashDv = products.getDefaultVariant(self.activeLeashKey) || (leashProductInit && leashProductInit.variants ? leashProductInit.variants[0] : null);
      if (leashDv) {
        self.selections['guinzaglio'] = {
          variantId: leashDv.id,
          color: leashDv.option1 || '',
          size:  leashDv.option2 || '',
          price: leashDv.price,
          compareAtPrice: leashDv.compareAtPrice || leashDv.price,
          image: leashDv.image || (products.getProduct(self.activeLeashKey) || {}).featuredImage || ''
        };
      }

      /* ── Init portabustine ── */
      var portProductInit = products.getProduct('portabustine');
      var portDv = products.getDefaultVariant('portabustine') || (portProductInit && portProductInit.variants ? portProductInit.variants[0] : null);
      if (portDv) {
        self.selections['portabustine'] = {
          variantId: portDv.id,
          color: portDv.option1 || '',
          size:  portDv.option2 || '',
          price: portDv.price,
          compareAtPrice: portDv.compareAtPrice || portDv.price,
          image: portDv.image || (products.getProduct('portabustine') || {}).featuredImage || ''
        };
      }

      /* ── Init free ebook ── */
      var ebookProduct = products.getProduct('ebook');
      var ebookDv      = products.getDefaultVariant('ebook');
      if (ebookProduct && ebookDv) {
        self.freeProducts['ebook'] = {
          variantId: ebookDv.id,
          price: ebookDv.price,
          compareAtPrice: ebookDv.compareAtPrice || 14.90,
          image: ebookDv.image || ebookProduct.featuredImage || '',
          title: ebookProduct.title
        };
      }

      /* ── Init Front D-Ring gratuito (verrà sincronizzato sulla taglia pettorina) ── */
      var frontProduct = products.getProduct('front_d_ring');
      var frontDv      = products.getDefaultVariant('front_d_ring');
      if (frontProduct && frontDv) {
        self.freeProducts['front_d_ring'] = {
          variantId: frontDv.id,
          price: 0,
          compareAtPrice: 9.99,
          image: frontDv.image || frontProduct.featuredImage || '',
          title: frontProduct.title,
          sizeLabel: frontDv.title || frontDv.option1 || ''
        };
      }

      this._syncFromPage();
      // Il tema puo' non esporre la variante iniziale: sincronizza anche il default.
      this._syncFrontDRing(this.selections.pettorina.size);
      this._watchPageVariant();
      this._recalculate();
      this._initialized = true;
      this._emit('init');
    },

    /* ─────────────────────────────────────────
       _syncFromPage — chiamato solo all'init.
       Legge il variantId attuale dalla pagina
       e lo usa per impostare colore E taglia
       iniziali (non c'è stato precedente).
    ───────────────────────────────────────── */
    _syncFromPage: function () {
      try {
        var variantInput = document.querySelector(
          'form[action*="/cart/add"] input[name="id"], ' +
          '.product-form input[name="id"], ' +
          '[data-product-form] input[name="id"]'
        );
        if (variantInput) {
          var vid = parseInt(variantInput.value, 10);
          if (vid) this._applyPageVariantFull(vid);
          return;
        }
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.selectedVariantId) {
          this._applyPageVariantFull(window.ShopifyAnalytics.meta.selectedVariantId);
        }
      } catch (e) { /* silent */ }
    },

    /* ─────────────────────────────────────────
       _applyPageVariantFull
       Usato SOLO all'init — accetta colore E taglia
       dalla variante della pagina così com'è.
    ───────────────────────────────────────── */
    _applyPageVariantFull: function (variantId) {
      var products = window.BauBundleProducts;
      if (!products) return;
      var product = products.getProduct('pettorina');
      if (!product) return;
      var variant = product.variants.find(function (v) { return v.id === variantId; });
      if (!variant || !variant.available) return;
      this._setPettorina(variant);
    },

    /* ─────────────────────────────────────────
       _applyColorChange
       Chiamato dai listener runtime (dopo init).
       Riceve il variantId dal tema ma usa SOLO
       il colore (option1) — mantiene la taglia
       corrente salvata nello state.
    ───────────────────────────────────────── */
    _applyColorChange: function (variantId) {
      var products = window.BauBundleProducts;
      if (!products) return;
      var product = products.getProduct('pettorina');
      if (!product) return;

      var incoming = product.variants.find(function (v) { return v.id === variantId; });
      if (!incoming) return;

      var newColor    = incoming.option1 || '';
      var currentColor = this.selections['pettorina'].color || '';
      var currentSize  = this.selections['pettorina'].size  || '';

      /* Se il colore non è cambiato, aggiorna anche la taglia
         (l'utente ha cliccato una taglia sulla pagina prodotto) */
      if (newColor === currentColor) {
        var newSize = incoming.option2 || '';
        if (newSize && newSize !== currentSize) {
          /* Taglia cambiata — accetta colore+taglia dal tema */
          if (incoming.available) {
            this._setPettorina(incoming);
          }
        }
        return;
      }

      /* Colore cambiato — mantieni la taglia corrente */
      var target = null;

      if (currentSize) {
        target = product.variants.find(function (v) {
          return v.option1 === newColor &&
                 v.option2 && v.option2.toLowerCase().trim() === currentSize.toLowerCase().trim() &&
                 v.available;
        });
      }

      /* Fallback: prima variante disponibile del nuovo colore */
      if (!target) {
        target = product.variants.find(function (v) {
          return v.option1 === newColor && v.available;
        });
      }

      if (!target) return;
      this._setPettorina(target);
    },

    _watchPageVariant: function () {
      var self = this;

      /* ── Input change listener ── */
      var attachInputListener = function () {
        var inputs = document.querySelectorAll(
          'form[action*="/cart/add"] input[name="id"], ' +
          '.product-form input[name="id"], ' +
          '[data-product-form] input[name="id"]'
        );
        inputs.forEach(function (input) {
          if (input._bauListenerAttached) return;
          input._bauListenerAttached = true;
          input.addEventListener('change', function () {
            var vid = parseInt(this.value, 10);
            if (vid) self._applyColorChange(vid);
          });
        });
      };

      attachInputListener();

      /* ── MutationObserver — rileva cambio value sull'input ── */
      var form = document.querySelector(
        'form[action*="/cart/add"], .product-form, [data-product-form]'
      );

      if (form) {
        var lastVid = null;
        var observer = new MutationObserver(function () {
          attachInputListener();
          var input = form.querySelector('input[name="id"]');
          if (!input) return;
          var vid = parseInt(input.value, 10);
          if (vid && vid !== lastVid) {
            lastVid = vid;
            self._applyColorChange(vid);
          }
        });
        observer.observe(form, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['value']
        });
      }

      /* ── Custom events del tema ── */
      document.addEventListener('variant:changed', function (e) {
        var variant = e.detail && (e.detail.variant || e.detail);
        if (variant && variant.id) self._applyColorChange(variant.id);
      });

      document.addEventListener('variantChange', function (e) {
        var variant = e.detail && e.detail.variant;
        if (variant && variant.id) self._applyColorChange(variant.id);
      });
    },

    _setPettorina: function (variant) {
      var products = window.BauBundleProducts;
      var product  = products.getProduct('pettorina');

      this.selections['pettorina'] = {
        variantId: variant.id,
        color: variant.option1 || '',
        size:  variant.option2 || '',
        price: variant.price,
        compareAtPrice: variant.compareAtPrice || variant.price,
        image: variant.image || product.featuredImage || ''
      };

      var color = variant.option1 || '';
      var size  = variant.option2 || '';

      var group       = getSizeGroup(size);
      var newLeashKey = (group && LEASH_KEY_FOR_GROUP[group]) || this.activeLeashKey;

      this.activeLeashKey = newLeashKey;
      this._syncLeashSize(color, size);
      this._syncColor('portabustine', color);
      this._syncFrontDRing(size);

      this._recalculate();
      this._emit('variant-changed', { productKey: 'pettorina', variant: variant });
    },


    _syncFrontDRing: function (petSize) {
      var products = window.BauBundleProducts;
      var product  = products && products.getProduct('front_d_ring');
      if (!product || !product.variants || !product.variants.length) return;

      var target = frontDTargetForHarness(petSize);
      if (!target) return;

      // Mai mantenere un vecchio D-Ring quando la taglia cambia.
      this.freeProducts.front_d_ring.variantId = null;
      var variant = product.variants.find(function (v) {
        return v.available && Number(v.price) === 0 && frontDVariantMatches(v, target);
      });

      if (!variant) {
        console.error('[BauBundle] BauRing gratuito non disponibile per taglia', petSize, 'target=', target);
        return;
      }

      this.freeProducts['front_d_ring'] = {
        variantId: variant.id,
        price: 0,
        compareAtPrice: 9.99,
        image: variant.image || product.featuredImage || '',
        title: product.title,
        sizeLabel: variant.title || variant.option1 || target
      };
    },

    _syncLeashSize: function (color, petSize) {
      var products     = window.BauBundleProducts;
      var leashKey     = this.activeLeashKey;
      var targetLabel  = LEASH_SIZE_LABEL[leashKey];
      var leashProduct = products.getProduct(leashKey);
      if (!leashProduct || !leashProduct.variants || !leashProduct.variants.length) return;

      var preferredColor = preferredLeashColor(color);
      var variants = leashProduct.variants.filter(function (v) { return v.available; });

      var variant = variants.find(function (v) {
        return normalize(v.option1) === normalize(preferredColor) &&
               normalize(v.option2) === normalize(targetLabel);
      });

      if (!variant) {
        variant = variants.find(function (v) {
          return normalize(v.option2) === normalize(targetLabel);
        });
      }

      if (!variant) variant = variants[0];
      if (!variant) return;

      this.selections['guinzaglio'] = {
        variantId: variant.id,
        color: variant.option1 || '',
        size:  variant.option2 || '',
        price: variant.price,
        compareAtPrice: variant.compareAtPrice || variant.price,
        image: variant.image || leashProduct.featuredImage || ''
      };
    },

    _syncColor: function (key, color) {
      var products = window.BauBundleProducts;
      var current  = this.selections[key];
      if (!current) return;

      var resolveKey = (key === 'guinzaglio') ? this.activeLeashKey : key;
      var product = products.getProduct(resolveKey);
      if (!product || !product.variants || !product.variants.length) return;

      var desiredColor = key === 'portabustine' ? preferredBagColor(color) : color;
      var variants = product.variants.filter(function (v) { return v.available; });
      var variant = null;

      if (current.size) {
        variant = variants.find(function (v) {
          return normalize(v.option1) === normalize(desiredColor) &&
                 normalize(v.option2) === normalize(current.size);
        });
      }

      if (!variant) {
        variant = variants.find(function (v) {
          return normalize(v.option1) === normalize(desiredColor);
        });
      }

      if (!variant) variant = variants[0];
      if (!variant) return;

      this.selections[key] = {
        variantId: variant.id,
        color: variant.option1 || '',
        size:  variant.option2 || '',
        price: variant.price,
        compareAtPrice: variant.compareAtPrice || variant.price,
        image: variant.image || product.featuredImage || ''
      };
    },

    selectVariant: function (productKey, variantId) {
      var products = window.BauBundleProducts;
      if (!products) return;

      var resolveKey = (productKey === 'guinzaglio') ? this.activeLeashKey : productKey;
      var product = products.getProduct(resolveKey);
      if (!product) return;

      var variant = product.variants.find(function (v) { return v.id === variantId; });
      if (!variant) return;

      if (productKey === 'pettorina') {
        this._setPettorina(variant);
      } else {
        this.selections[productKey] = {
          variantId: variant.id,
          color: variant.option1 || '',
          size:  variant.option2 || '',
          price: variant.price,
          compareAtPrice: variant.compareAtPrice || variant.price,
          image: variant.image || product.featuredImage || ''
        };
        this._recalculate();
        this._emit('variant-changed', { productKey: productKey, variant: variant });
      }
    },

    selectByColorSize: function (productKey, color, size) {
      var products = window.BauBundleProducts;
      if (!products) return;

      var resolveKey = (productKey === 'guinzaglio') ? this.activeLeashKey : productKey;
      var product = products.getProduct(resolveKey);
      if (!product || !product.variants) return;

      var variant = product.variants.find(function (v) {
        var colorMatch = !color || normalize(v.option1) === normalize(color);
        var sizeMatch  = !size  || normalize(v.option2) === normalize(size);
        return colorMatch && sizeMatch && !!v.available;
      });

      if (variant) this.selectVariant(productKey, variant.id);
    },

    toggleDropdown: function (productKey) {
      this.openDropdown = (this.openDropdown === productKey) ? null : productKey;
      this._emit('dropdown-changed', { openDropdown: this.openDropdown });
    },

    closeDropdown: function () {
      if (this.openDropdown) {
        this.openDropdown = null;
        this._emit('dropdown-changed', { openDropdown: null });
      }
    },

    _recalculate: function () {
      var paid = 0;
      var freeSavings = 0;
      var self = this;

      ['pettorina', 'guinzaglio'].forEach(function (key) {
        paid += self.selections[key].price || 0;
      });

      freeSavings += this.selections['portabustine'].compareAtPrice || 0;

      Object.values(this.freeProducts).forEach(function (fp) {
        freeSavings += fp.compareAtPrice || 0;
      });

      this.subtotal  = paid;
      this.fullPrice = paid + freeSavings;
      this.savings   = freeSavings;
    },

    getState: function () {
      return {
        selections:     Object.assign({}, this.selections),
        freeProducts:   Object.assign({}, this.freeProducts),
        openDropdown:   this.openDropdown,
        activeLeashKey: this.activeLeashKey,
        subtotal:       this.subtotal,
        fullPrice:      this.fullPrice,
        savings:        this.savings
      };
    },

    getLineItems: function () {
      var items = [];
      var self  = this;

      /* 1. Pettorina */
      var pet = self.selections['pettorina'];
      if (!pet.variantId || !pet.size) throw new Error('Scegli la taglia della pettorina.');
      items.push({ id: pet.variantId, quantity: 1, properties: {} });

      /* 2. Guinzaglio */
      var leash = self.selections['guinzaglio'];
      if (!leash.variantId) throw new Error('Il guinzaglio non e disponibile in questa taglia.');
      items.push({ id: leash.variantId, quantity: 1, properties: {} });

      /* 3. Portabustine gratuito */
      var port = self.selections['portabustine'];
      if (!port.variantId) throw new Error('Seleziona il portabustine.');

      /* Risoluzione robusta del portabustine GRATUITO.
         Il prodotto paid può chiamare il rosa "Sakura Edition", mentre quello free
         può chiamarlo semplicemente "Rosa". Per questo non usiamo più un match esatto. */
      var freeVariants = window.BauBundleProducts ? window.BauBundleProducts.getVariants('portabustine_free') : [];
      var paidColor = normalize(port.color);
      var wantedBagColor = 'grigio';
      if (paidColor.indexOf('sakura') !== -1 || paidColor.indexOf('rosa') !== -1 || paidColor.indexOf('pink') !== -1) wantedBagColor = 'rosa';
      else if (paidColor.indexOf('crimson') !== -1 || paidColor.indexOf('rosso') !== -1 || paidColor.indexOf('red') !== -1) wantedBagColor = 'rosso';
      else if (paidColor.indexOf('lucky') !== -1 || paidColor.indexOf('verde') !== -1 || paidColor.indexOf('green') !== -1) wantedBagColor = 'verde';

      var freeVariant = freeVariants.find(function (v) {
        var hay = normalize([v.title, v.option1, v.option2, v.option3].filter(Boolean).join(' '));
        return Number(v.price) === 0 && hay.indexOf(wantedBagColor) !== -1;
      });
      if (!freeVariant) freeVariant = freeVariants.find(function (v) { return Number(v.price) === 0; });

      if (!freeVariant || Number(freeVariant.price) !== 0) {
        throw new Error('Portabustine gratuito non disponibile: acquisto bloccato per evitare addebiti.');
      }

      items.push({ id: freeVariant.id, quantity: 1, properties: {
        '_bundle_gift': 'true',
        '_bundle_role': 'portabustine'
      }});

      /* 4. BauBook gratuito */
      var ebook = self.freeProducts['ebook'];
      if (!ebook || !ebook.variantId || ebook.price !== 0) throw new Error('BauBook gratuito non disponibile.');
      items.push({ id: ebook.variantId, quantity: 1, properties: {
        '_bundle_gift': 'true',
        '_bundle_role': 'ebook'
      }});

      /* 5. BauRing / Front D-Ring gratuito. La variante resta sincronizzata
         automaticamente con la Pettorina, ma non mostriamo la taglia al cliente. */
      var front = self.freeProducts['front_d_ring'];
      if (!front || !front.variantId || front.price !== 0) throw new Error('BauRing gratuito non disponibile per questa taglia.');
      items.push({ id: front.variantId, quantity: 1, properties: {
        '_bundle_gift': 'true',
        '_bundle_role': 'front_d_ring',
        '_linked_harness_size': pet.size || ''
      }});

      // Un ID per aggiunta; lega i regali al loro acquisto anche con piu' bundle.
      var bundleId = 'bau-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      items.forEach(function (item) {
        item.properties = item.properties || {};
        item.properties._bau_bundle_id = bundleId;
      });
      return items;
    },

    _emit: function (type, detail) {
      detail = detail || {};
      window.dispatchEvent(new CustomEvent('bau-bundle:state-changed', {
        detail: Object.assign({ type: type, state: this.getState() }, detail)
      }));
    }
  };

  window.BauBundleState = BauBundleState;
})();